// extracted by mini-css-extract-plugin
export var branding = "header-module--branding--JLg2Y";
export var mobileNav = "header-module--mobileNav--XPsTq";
export var nav = "header-module--nav--AAvii";
export var phoneHeader = "header-module--phoneHeader--wMOGT";
export var siteName = "header-module--siteName--oLZkL";
export var slogan = "header-module--slogan--BCPuz";
export var toggleNavButton = "header-module--toggleNavButton--r5IRV";
export var topHeader = "header-module--topHeader--fNXWq";